import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'v2m-blog-scriptaction',
  templateUrl: './blog-scriptaction.component.html',
  styleUrls: ['./blog-scriptaction.component.scss']
})
export class BlogScriptactionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
